/* FM Geo M2 — auto-advancing image slider. No deps.
   Pauses on hover/focus, when the tab is hidden, when scrolled out of view,
   and entirely when the visitor prefers reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.fmAutoInit === '1') return;
    root.dataset.fmAutoInit = '1';

    var track = root.querySelector('[data-fm-autoslide-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.fm-geo-m2-autoslide__slide');
    if (slides.length <= 1) return;

    var dotsWrap = root.querySelector('[data-fm-autoslide-dots]');
    var interval = parseInt(root.dataset.fmAutoslideInterval, 10) || 2000;
    var index = 0;
    var timer = null;
    var visible = true;
    var hovered = false;

    var dots = [];
    if (dotsWrap) {
      for (var i = 0; i < slides.length; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'fm-geo-m2-autoslide__dot';
        b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
        (function (n) {
          b.addEventListener('click', function () { go(n); restart(); });
        })(i);
        dotsWrap.appendChild(b);
        dots.push(b);
      }
    }

    function go(n) {
      index = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
        dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
      }
    }

    function tick() { go(index + 1); }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function start() {
      if (reduce || timer || !visible || hovered || document.hidden) return;
      timer = setInterval(tick, interval);
    }

    function restart() { stop(); start(); }

    root.addEventListener('mouseenter', function () { hovered = true; stop(); });
    root.addEventListener('mouseleave', function () { hovered = false; start(); });
    root.addEventListener('focusin', function () { hovered = true; stop(); });
    root.addEventListener('focusout', function () { hovered = false; start(); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { start(); }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) { start(); } else { stop(); }
      }, { threshold: 0.2 }).observe(root);
    }

    go(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-fm-autoslide]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
